const EthicsScreen = () => {

    return(
        <p>Ethics Screen</p>
    )
}

export default EthicsScreen